import { PRODUCT_IDEA_API } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";

type TProductIdeaFormProps = {
	closeModal: () => void;
};

export default function ProductIdeaForm({ closeModal: closeModal }: TProductIdeaFormProps) {
	const [data, setData] = useState({ name: "", email: "", description: "" });

	const [errorMessage, setErrorMessage] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		try {
			setIsLoading(true);

			const url = new URL(PRODUCT_IDEA_API);

			const res = await fetch(url, {
				method: "POST",
				body: JSON.stringify(data),
			});

			const body = await res.json();
			const message = body?.message;

			if (res.ok) {
				toast.success(message);
			} else {
				toast.error(message);
			}

			closeModal();

			setErrorMessage("");
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setData({
			...data,
			[e.target.name]: e.target.value,
		});
	};

	return (
		<>
			<p className="text-gray-600">
				Our dedicated team will review your submission and, upon review, get back to you in less
				than 24 hours on how to build your product with us.
			</p>

			<form onSubmit={onSubmit}>
				<div className="flex flex-col gap-2">
					<label className="mb-1 mt-6 text-gray-600">Name</label>
					<input
						type="text"
						name="name"
						value={data.name}
						onChange={onChange}
						placeholder="Enter your name here"
						className="w-full rounded-lg border border-slate-300 p-4 focus:outline-gray-200"
						required
					/>

					<label className="mb-1 mt-6 text-gray-600">Email</label>
					<input
						type="email"
						name="email"
						value={data.email}
						onChange={onChange}
						placeholder="Enter your email here"
						className="w-full rounded-lg border border-slate-300 p-4 focus:outline-gray-200"
						required
					/>

					<label className="mb-1 mt-6 text-gray-600">Describe your product</label>
					<textarea
						placeholder="Type here"
						name="description"
						value={data.description}
						onChange={onChange}
						className="w-full rounded-lg border border-slate-300 p-4 focus:outline-gray-200"
						required
					/>

					<button className="mt-6 rounded-lg bg-brand-primary px-8 py-4 text-center text-lg font-semibold text-white">
						{isLoading ? (
							<Loader2Icon className="mx-auto h-8 w-8 animate-spin stroke-white" />
						) : (
							"Submit"
						)}
					</button>
				</div>
			</form>

			<p
				className={cn(
					"text-sm text-red-400 transition-opacity duration-150 ease-linear",
					errorMessage ? "opacity-100" : "opacity-0"
				)}
			>
				{errorMessage}
			</p>
		</>
	);
}
